import React, { useEffect, useState, useRef } from 'react'
import '.././App.css';
import Swal from 'sweetalert2';
import { auth, db } from '../firebase';
import { collection, query, orderBy, onSnapshot, getDoc, doc, where, getAggregateFromServer, sum, } from 'firebase/firestore'
import moment from 'moment';
import Select from 'react-select'
import { useReactToPrint } from 'react-to-print';


export default function Productwise() {
    const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
    });
    const [userData, setUserData] = useState();

    useEffect(() => {
        auth.onAuthStateChanged((user) => {
            setUserData(user);
        });
    });

    useEffect(() => {
        const today = new Date();
        const formattedDate = today.toISOString().split('T')[0];
        setfromdate(formattedDate);
        settodate(formattedDate);
    }, []);

    const printRef = useRef();
    const [reportData, setreportData] = useState([]);
    const [fromdate, setfromdate] = useState("");
    const [todate, settodate] = useState("");
    const [totalamount, settotalamount] = useState("");

    const handlePrint = useReactToPrint({
        content: () => printRef.current,
    })


    const getReport = () => {
        settotalamount(0);
        setreportData([]);

        const q1 = query(collection(db, 'orderitems'), where('orderdate', '>=', fromdate), where('orderdate', '<=', todate));

        onSnapshot(q1, async (querySnapshot1) => {
            const productMap = new Map();
            let totalAmount = 0;

            querySnapshot1.forEach((doc1) => {
                const data = doc1.data();
                const key = data.itemname;

                if (!productMap.has(key)) {
                    productMap.set(key, {
                        itemname: data.itemname,
                        rate: parseFloat(data.rate),
                        quantity: parseFloat(data.quantity),
                        total: parseFloat(data.rate) * parseFloat(data.quantity),
                    });
                } else {
                    const existing = productMap.get(key);
                    existing.quantity += parseFloat(data.quantity);
                    existing.total += parseFloat(data.rate) * parseFloat(data.quantity);
                }

                totalAmount += parseFloat(data.rate) * parseFloat(data.quantity);
            });

            // Convert Map to Array and sort alphabetically by itemname
            const combinedData = Array.from(productMap.values()).sort((a, b) =>
                a.itemname.localeCompare(b.itemname)
            );

            settotalamount(totalAmount.toFixed(2));
            setreportData(combinedData);
        });
    };


    return (
        <div>
            <div className="content-wrapper">
                <section className="content">
                    <div className="container-fluid">
                        <button className="btn btn-secondary" style={{ float: "right" }} >|| Product Wise Report  ||</button><br /><br />
                        <div className="card card-primary card-outline">
                            <div className="card-body table-responsive p-3" >
                                <div className='row '>
                                    <div className="col-sm-3">
                                        <label> From Date </label>
                                        <input type="date" className="form-control" style={{ height: 35, fontSize: 14 }} value={fromdate} onChange={(e) => setfromdate(e.target.value)} />
                                    </div>
                                    <div className="col-sm-3">
                                        <label> To Date </label>
                                        <input type="date" className="form-control" style={{ height: 35, fontSize: 14 }} value={todate} onChange={(e) => settodate(e.target.value)} />
                                    </div>
                                    <div className='col-sm-3'>
                                        <br />
                                        <button onClick={() => getReport()} className='btn btn-info'>Get Report</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="card card-primary card-outline">
                            <div className="card-body table-responsive p-3" ref={printRef}>
                                <center>
                                    <h6>Pratik Bar</h6>
                                    <span>Tuljapur By Pass, Bhavani Chouk, Dharashiv, 413601</span><br />
                                    {/* <span>Mobile No: 9921060146</span> */}
                                </center><hr />
                                <div className='row'>
                                    <div className='col-sm-4'>
                                        <span><b>From Date : </b>{moment(fromdate).format('DD/MM/YYY')}</span>
                                    </div>
                                    <div className='col-sm-4 text-center'>
                                        <h6 style={{ textTransform: "uppercase" }}>Product Wise Report</h6>
                                    </div>
                                    <div className='col-sm-4' style={{textAlign:"right"}}>
                                        <span><b>To Date : </b>{moment(todate).format('DD/MM/YYY')}</span>
                                    </div>
                                </div>
                                <div className='row '>
                                    <table className='table table-striped'>
                                        <tr>
                                            <th>Sr No</th>
                                            <th>Date</th>
                                            <th>Prodcut Name</th>
                                            <th>Rate</th>
                                            <th>Quantity</th>
                                            <th>Total</th>

                                        </tr>
                                        <tr>
                                            <td colSpan={4}><b>Total</b></td>
                                            <td><b></b></td>
                                            <td><b>{totalamount}</b></td>
                                        </tr>
                                        {
                                            reportData.map((item, index) => (
                                                <tr key={index}>
                                                    <td>{index + 1}</td>
                                                    <td>{moment(fromdate).format('DD-MM-YYYY')}</td>
                                                    <td>{item.itemname}</td>
                                                    <td>{item.rate}</td>
                                                    <td>{item.quantity}</td>
                                                    <td>{item.total.toFixed(2)}</td>
                                                </tr>
                                            ))
                                        }


                                    </table>
                                </div>
                            </div>
                            <center>
                                <button onClick={handlePrint} className='btn btn-info'>Print Report</button>
                            </center><br />
                        </div>
                    </div>
                </section>
            </div>
        </div>
    )
}
